import { countries } from "../const/countries";

export const initialFormRegister = {
  usuario: "",
  clave: "",
  cedula: "",
  nombre: "",
  email: "",
  fecha_nac: "",
  country: "",
  address: "",
  type_doc: "",
  moneda: "",
  codigoAgente: "",
  over18: "",
  telefono: "",
  acceptConditions: "",
  acceptConditionsPromo: "",
  countryCode: "+54",
  letraONumero: '',
  area: ''
};

export const validationsForm = (form) => {
  let errors = {};
  let regexName = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü0123456789@-_.#!$%*+=?/&\s]+$/;
  let regexEmail = /^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}$/;
  let regexPassword = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü0123456789@-_.#!$%*+=?/&\s]+$/;
  let regexPhone =
    /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
  let birthday = new Date(form.fecha_nac);
  let today = new Date();

  if (!form.usuario.trim()) {
    errors.usuario = "Ingrese un nombre de usuario.";
  } else if (!regexName.test(form.usuario)) {
    errors.usuario = `El nombre de usuario '${form.usuario}' no es permitido, solo se aceptan: letras, números y los carácteres: @ - _ . # ! $ % * + = ?`;
  }

  if (!form.cedula.trim()) {
    errors.cedula = "Ingrese su documento de identidad.";
  }

  let errCedula = validarCedula(form.type_doc, form.cedula, form.country);
  if (errCedula!==false) {
    errors.cedula = errCedula
  }

  if (!form.address.trim()) {
    errors.address = "Ingrese su direccion o residencia.";
  }

  if (!form.fecha_nac) {
    errors.fecha_nac = "Ingrese su fecha de nacimiento.";
  }

  if (!form.telefono.trim()) {
    errors.telefono = "Ingrese su número de télefono.";
  } else if (validatePhone(form.telefono, form.country)) {
    errors.telefono = validatePhone(form.telefono, form.country)
  } else if (!regexPhone.test(form.telefono.trim())) {
    errors.telefono = "Ingrese un número de teléfono válido.";
  }

  if (!form.moneda) {
    errors.moneda = "Seleccione la moneda de su preferencia.";
  } else if (form.moneda === "default") {
    errors.moneda = "Seleccione la moneda de su preferencia.";
  }
  if (!form.over18) {
    errors.over18 = "Debe ser mayor de edad para registrarse.";
  }
  if (!form.acceptConditions) {
    errors.acceptConditions =
      "Debe aceptar los términos y condiciones para continuar.";
  }

  if (!form.acceptConditionsPromo) {
    errors.acceptConditionsPromo =
      "Debe aceptar el envio de las promociones y novedades para continuar.";
  }

  if (!form.nombre.trim()) {
    errors.nombre = "Ingrese su nombre completo.";
  }

  if (!validarNombre(form.nombre.trim())) {
    errors.nombre = "Caracteres especiales no permitidos !”#$%&//()=<>";
  }

  if (!form.email.trim()) {
    errors.email = "Ingrese su correo electrónico.";
  } else if (!regexEmail.test(form.email.trim())) {
    errors.email = "Ingrese una dirección de correo válida.";
  }

  if (form.clave.trim() && !regexPassword.test(form.clave.trim())) {
    errors.clave =
      "La contraseña no es permitida, solo se aceptan: letras, números y los caracteres: @ - _ . # ! $ % * + = ?";
  } 
  

  if (today.getFullYear() - birthday.getFullYear() < 18) {
    if (today.getFullYear() - birthday.getFullYear() === 17) {
      if (today.getMonth() >= birthday.getMonth()) {
        if (today.getDate() < birthday.getDate()) {
          errors.fecha_nac = "Debe ser mayor de edad para registrarse.";
        }
      } else errors.fecha_nac = "Debe ser mayor de edad para registrarse.";
    } else errors.fecha_nac = "Debe ser mayor de edad para registrarse.";
  }

  return errors;
};

export const validarNombre = (string) => {
  const caracteresProhibidos = /[!"#$%&\/()=<>]/;

  if (caracteresProhibidos.test(string)) return false;
  return true;
};

export const validarCedula = (tipo, value, pais) => {
  let country = countries.find(x=>x.flag===pais)
  if(country) {
    let doc = country.documents.find(x=>x.value===tipo)
    if(doc) {
      let min = doc.min || 0,
        max = doc.max || 100000;
    
      const length = value.length;
      if (length < min || length > max) {
      if(min===max) return `Su documento debe constar de ${min} caracteres.`
      else if(max===100) return `Su documento debe poseer al menos ${min} caracteres.`
        return `Su documento debe tener entre ${min} y ${max} caracteres`;
      }
    }
  }

  return false;
};


const validatePhone = (phone, country) => {
  const pais = countries.find(x=>x.flag===country);
  if(!pais) return false
  if(phone.length > pais.phone || phone.length < pais.phone) return `Su número de télefono debe constar de ${pais.phone} caracteres.`
  return false
}